import { escrowOfficerCard, insertIntoArray } from '../../shared';
import type { OfferLocaleOverrides } from '../base';

export const WAOverrides: OfferLocaleOverrides = {
  locale: 'WA',
  sections: {
    propertyInfo: {
      cards: {
        propertyBeingSoldCard: {
          layout: (layout) =>
            layout.concat([
              [
                {
                  name: 'property.taxIdNumber',
                  size: 100,
                },
              ],
              [
                {
                  name: 'property.legalDescription',
                  size: 100,
                },
              ],
            ]),
          fields: {
            taxIdNumber: {
              name: 'property.taxIdNumber',
              entity: 'property',
              type: 'text',
              label: 'Property Tax ID Number',
              placeholderText: '',
            },
            legalDescription: {
              name: 'property.legalDescription',
              entity: 'property',
              type: 'textarea',
              label: 'Legal Description',
              placeholderText: '',
            },
          },
        },
        salesPriceCard: {
          layout: (layout) =>
            insertIntoArray(layout, 1, [
              {
                name: 'salesAgreementNumber',
                size: 100,
              },
            ]),
          fields: {
            salesAgreementNumber: {
              name: 'salesAgreementNumber',
              entity: 'interaction',
              type: 'text',
              label: 'Sales Agreement Number',
              placeholderText: '',
            },
          },
        },
      },
    },
    additionalContacts: {
      cards: {
        escrow: {
          ...escrowOfficerCard,
          order: -1,
        },
      },
    },
  },
};
